// @flow

import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';
import PlaceholderLoader from './PlaceholderLoader';

export const MlFontIconLoader = PlaceholderLoader(MlFontIcon);

export default MlFontIconLoader;
